import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-email-verificado',
  templateUrl: './email-verificado.component.html',
  styleUrls: ['./email-verificado.component.scss']
})
export class EmailVerificadoComponent implements OnInit {

  status: string = 'invalid';

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.status = this.route.snapshot.queryParamMap.get('status') || 'invalid';
  }
}